// Additional filters are cached here.
let additionalFilters = null;
const sentryFiltersUrl = process.env.SENTRY_FILTERS_URL;

function fetchAdditionalFilters() {
  return new Promise((resolve, reject) => {
    // Attempt to load additional filters from url. If it fails, use empty filters.
    fetch(sentryFiltersUrl)
      .then((resp) => {
        resp
          .json()
          .then((filters) => {
            resolve(filters);
          })
          .catch(() => {
            resolve({});
          });
      })
      .catch(() => {
        resolve({});
      });
  });
}

export default function (context) {
  return {
    environment: process.env.SENTRY_ENV,
    tracesSampleRate: 0.1,
    sampleRate: 0.25,
    allowUrls: [],
    denyUrls: [
      "prebid",
      "cdn-cgi",
      "chrome-extension",
      "safari-extension",
      "yieldmo.com",
      "flashtalking.com",
      "amazon-adsystem",
      "yahoo.com",
      "sys.com",
      "doubleclick.net",
      "3lift.com",
      "openx.net",
      "casalemedia.com",
      "smartadserver.com",
      "adnxs.com",
      "google-analytics.com",
      "bidswitch.net",
      "ipify.org",
      "sascdn.com",
      "js7k.com",
      "githubusercontent.com",
      "raw.githubusercontent.com",
      "moatads.com",
      "yimg.com",
      "media.net",
      "adform.net",
      "media.innity.net",
      "2mdn.net",
      "acdn.adnxs-simple.com",
      "cdn.doubleverify.com",
      "assets.amxrtb.com",
      "metrics.nt.vc",
      "btloader.com",
      "imasdk.googleapis.com",
      "cdns.helion.exchange",
      "j.adlooxtracking.com",
      "player.aniview.com",
      "wisepops.com",
      "wisepops.net",
      "activity.wisepops.com",
      "cdn.wisepops.com",
      "notifications.wisepops.com",
      "t.richaudience.com",
      "cache-ssl.celtra.com",
      "static.cloudflareinsights.com",
      "trackmenow.life",
      "ad-score.com",
      "seedtag.com",
      "clarity.ms"
    ],
    ignoreErrors: [
      "prebid",
      "reading '$el'",
      "reading 'focus'",
      "Blocked a restricted frame",
      "getBoundingClientRect",
      "evaluating 'window.open",
      "Custom cursors with size greater than",
      "Network Error",
      "hostname could not be found",
      "'active' of undefined",
      "Load failed",
      "e is null",
      "$el",
      "Cannot read properties of undefined (reading",
      "Custom cursors with size greater",
      "ReportingObserver",
      "ResizeObserver",
      "window.open",
      "chrome-extension",
      "Cannot read property 'focus' of null",
      "Non-Error promise rejection captured with value",
      "Non-Error promise rejection captured with keys",
      "Failed to fetch",
      "scrollX",
      "Failed to read the 'sessionStorage' property from 'Window'",
      "getViewportGeometry",
      "NetworkError when attempting to fetch resource",
      "Cannot read property 'disconnect' of null",
      "Node.appendChild: Cannot add children to a Comment",
      "timeout of 0ms exceeded",
      "Request aborted",
      "Dropbox.choose and Dropbox.save",
      "createCORSRequest",
      "this.kdmw",
      "IndexedDB connection terminated",
      "Document is not fully active",
      "navigator.userAgentData.getHighEntropyValues",
      "Object captured as promise rejection with keys: qa",
      "NS_ERROR_NOT_INITIALIZED",
      "('video')[0].src",
      "CustomEvent"
    ],
    // We can use this callback to apply custom filteration to sending events.
    // This callback will get fired only if the error is not ignored through above hard-coded rules.
    // return null from this means don't send the event to Sentry.
    async beforeSend(event, hint) {
      if (!additionalFilters) {
        additionalFilters = await fetchAdditionalFilters();
      }

      const currentUrl =
        event && event.request && event.request.url
          ? event.request.url.toLowerCase()
          : null;

      // Perform url checks if 'onlyAllowUrls' is specified in sentry filters.
      if (additionalFilters.onlyAllowUrls) {
        if (!currentUrl) {
          // Block the event if url not detected.
          return null;
        }

        const match = additionalFilters.onlyAllowUrls.find((allowed) =>
          currentUrl.includes(allowed)
        );
        if (!match) {
          // Block the event if not matching with allowed urls.
          return null;
        }
      }

      // Perform url checks if 'blockUrls' is specified in sentry filters.
      if (additionalFilters.blockUrls && currentUrl) {
        const match = additionalFilters.blockUrls.find((blocked) =>
          currentUrl.includes(blocked)
        );
        if (match) {
          // Block the event if matching with blocked urls.
          return null;
        }
      }

      // Perform message checks if 'ignore' rules are specified in sentry filters.
      if (additionalFilters.ignore) {
        const ignoreList = additionalFilters.ignore;
        const error = (hint && hint.originalException) || event.message || "";

        let msg = null;
        if (typeof error === "string" || error instanceof String) {
          msg = error.toLowerCase();
        } else if (error.message && typeof error.message === "string") {
          msg = error.message.toLowerCase();
        }

        if (msg) {
          const match = ignoreList.find((item) =>
            msg.includes(item.toLowerCase())
          );
          if (match) return null;
        }
      }

      // No filteration applied.
      return event;
    },
  };
}
